import { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function MagneticButton({
  children,
  onClick,
  variant = "solid",
  className = "",
  as: As = "button",
  href,
  ...rest
}) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 220, damping: 18, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 220, damping: 18, mass: 0.4 });

  const handleMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    x.set((e.clientX - cx) * 0.25);
    y.set((e.clientY - cy) * 0.35);
  };
  const reset = () => { x.set(0); y.set(0); };

  const base = "inline-flex items-center justify-center gap-3 px-9 py-4 text-[11px] uppercase tracking-[0.22em] font-medium transition-colors duration-500 will-change-transform relative";
  const variants = {
    solid: "bg-espresso text-ivory hover:bg-terracotta",
    outline: "border border-espresso/40 text-espresso hover:bg-espresso hover:text-ivory",
    ivory: "bg-ivory text-espresso hover:bg-terracotta hover:text-ivory",
    terracotta: "bg-terracotta text-ivory hover:bg-espresso",
  };

  const content = (
    <motion.span
      style={{ x: sx, y: sy }}
      className="flex items-center gap-3"
    >
      {children}
    </motion.span>
  );

  if (As === "a" || href) {
    return (
      <a
        ref={ref}
        href={href}
        onMouseMove={handleMove}
        onMouseLeave={reset}
        onClick={onClick}
        className={`${base} ${variants[variant]} ${className}`}
        {...rest}
      >
        {content}
      </a>
    );
  }

  return (
    <button
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      onClick={onClick}
      className={`${base} ${variants[variant]} ${className}`}
      {...rest}
    >
      {content}
    </button>
  );
}
